import { TextField } from "@material-ui/core";
import React from "react";
import QInputProps from "./QInputProps";

export default function QTextParagraph(p: QInputProps) {
  return <TextField placeholder="Your answer" fullWidth multiline rows={4} value={p.value || ""} onChange={e => {p.onValueChange(e.target.value || null)}}/>
}